import { render } from "./Loading.vue?vue&type=template&id=303629e8"
import script from "./Loading.vue?vue&type=script&lang=ts"
export * from "./Loading.vue?vue&type=script&lang=ts"
script.render = render

export default script